import { storeManager } from '../../../core/store/store-manager.ts';
import { Logger } from '../../../core/helpers/logger.ts';
import { prescript } from '../../../core/providers/prescript.ts';
import { api } from '../../../core/api/client.ts';
import { bodyMeasurements } from '../constants/body-measurements.ts';
import type { BodyMeasurements } from '../types/body-measurements.ts';
import { broadcastCookieUpdateToIframes } from './utils/iframe-broadcast.ts';
import { globalEventManager } from '../../../core/events/event-manager.ts';

export async function getRecommendedSizeEventHandler(payload: { data?: BodyMeasurements }) {
	try {
		const userMeasurements = (payload && payload.data) as BodyMeasurements;
		const data = await fetchUserProfile(userMeasurements);
		if (!data.persona_hash) return;

		storeManager.setCookie({
			name: 'SIZEBAY_PERSONA_HASH',
			value: data.persona_hash,
		});

		globalEventManager.dispatch('fh:sync-recommendation', { permalink: prescript.permalink });

		broadcastCookieUpdateToIframes({ closeModal: true });
	} catch {
		const IframeMap = {
			similar: document.getElementById('fashion-hint-iframe-similar'),
			complementary: document.getElementById('fashion-hint-iframe-complementary'),
			drawer: document.getElementById('fashion-hint-iframe-drawer'),
		};

		for (const key in IframeMap) {
			const iframe = IframeMap[key];
			if (!iframe) continue;
			iframe.contentWindow?.postMessage({ id: 'szb_error_creating_profile' }, '*');
		}
	}
}

async function fetchUserProfile(userMeasurements: BodyMeasurements) {
	try {
		const response = await api.post(
			`${prescript.baseVrfUrl}api/me/user/profile`,
			{
				...bodyMeasurements,
				...userMeasurements,
				userId: storeManager.getCookie('SIZEBAY_SESSION_ID_V4'),
			},
			{
				params: {
					sid: storeManager.getCookie('SIZEBAY_SESSION_ID_V4'),
					pre_predicted: true,
					sizeSystem: prescript.sizeSystem,
				},
			}
		);

		return response.data;
	} catch (error) {
		Logger.error('Error fetching user profile:', error);
	}
}
